<template>
<li>
    <a href="/inventory/bookings/"><i class="fa fa-cubes"></i> Inventory</a>
</li>
</template>

<script>
export default {
    //
}
</script>
